export const PROGRAM_STEPS = [
  { id: "projects", label: "Projects", summary: "Modernization workstreams and WBS — application is not a project." },
  { id: "execution", label: "Waves", summary: "Wave order, dependencies, milestones and readiness." },
  { id: "govern", label: "Governance", summary: "Planning, RAID, alerts, approvals and copilot." },
];

export const PROGRAM_FLOWS = [
  { id: "overview", label: "Analytics" },
  ...PROGRAM_STEPS,
];

export const PROGRAM_FOCUS = {
  overview: {
    title: "Modernization analytics",
    detail: "Programme health and pipeline — one screen before step detail.",
  },
  projects: {
    title: "Modernization projects",
    detail: "Level 2 workstreams — an application is not a project.",
  },
  execution: {
    title: "Waves, dependencies & milestones",
    detail: "Wave intelligence is Step 7. Live Jira is not replaced.",
  },
  govern: {
    title: "Planning, RAID & approvals",
    detail: "Structured inputs, alerts and governance outcomes — not a calendar product.",
  },
};

/** Program step drill-down — one pane per screen inside govern / execution modules. */

export const PROGRAM_GOVERN_PANES = [
  { id: "overview", label: "Overview" },
  { id: "charter", label: "Charter & risks" },
  { id: "planning", label: "Planning" },
  { id: "inputs", label: "Structured inputs" },
  { id: "raid", label: "RAID" },
  { id: "alerts", label: "Cutover alerts" },
  { id: "dashboard", label: "Dashboard" },
  { id: "approvals", label: "Approvals" },
  { id: "copilot", label: "Copilot" },
];

export const PROGRAM_EXECUTION_PANES = [
  { id: "overview", label: "Overview" },
  { id: "dependencies", label: "Dependencies" },
  { id: "waves", label: "Waves" },
  { id: "milestones", label: "Milestones" },
  { id: "readiness", label: "Readiness" },
  { id: "hypercare", label: "Hypercare" },
];

export const PROGRAM_GOVERN_DRILL = PROGRAM_GOVERN_PANES.filter((p) => p.id !== "overview");
export const PROGRAM_EXECUTION_DRILL = PROGRAM_EXECUTION_PANES.filter((p) => p.id !== "overview");

export const PROGRAM_GOVERN_PANE_DETAIL = {
  overview: "Charter, RAID, alerts and approvals — pick one topic.",
  charter: "Program charter, red risks and core counts.",
  planning: "Planning questions and derived programme summary.",
  inputs: "Twenty structured input categories with provenance.",
  raid: "Risks, assumptions, issues and dependencies.",
  alerts: "Cutover emails to function owners.",
  dashboard: "Pipeline metrics — not a BI product.",
  approvals: "Gate approval chain by role.",
  copilot: "Derived Q&A — not live LLM in POC.",
};

export const PROGRAM_EXECUTION_PANE_DETAIL = {
  overview: "Dependencies, waves, milestones and readiness — one screen each.",
  dependencies: "First-class dependency entities and CSV ingest.",
  waves: "Committed vs recommended wave intelligence.",
  milestones: "Milestone tracker per wave.",
  readiness: "Production readiness checks per app.",
  hypercare: "Post-deploy hypercare tracker.",
};

const LEGACY_MODULE_TO_STEP = {
  planning: "govern",
  inputs: "govern",
  dashboard: "govern",
  copilot: "govern",
  approvals: "govern",
  raid: "govern",
  alerts: "govern",
  waves: "execution",
  milestones: "execution",
  readiness: "execution",
  hypercare: "execution",
  dependencies: "execution",
};

export function resolveProgramModule(raw) {
  const id = raw || "overview";
  if (LEGACY_MODULE_TO_STEP[id]) return LEGACY_MODULE_TO_STEP[id];
  return id;
}

export function resolveProgramPane(module, rawModule, rawPane) {
  if (rawPane) return rawPane;
  if (rawModule && LEGACY_MODULE_TO_STEP[rawModule]) return rawModule;
  return "overview";
}

export function programView(searchParams) {
  const programId = searchParams.get("program");
  const rawModule = searchParams.get("module");
  if (!programId) return "list";
  const module = resolveProgramModule(rawModule);
  if (!rawModule || module === "overview") return "analytics";
  return "step";
}

export function programListHref() {
  return "/program";
}

export function programAnalyticsHref(programId) {
  if (!programId) return programListHref();
  return `/program?program=${encodeURIComponent(programId)}`;
}

export function programStepHref(programId, module, pane) {
  if (!programId) return programListHref();
  const params = new URLSearchParams({ program: programId });
  if (module && module !== "overview") params.set("module", module);
  if (pane && pane !== "overview") params.set("pane", pane);
  return `/program?${params.toString()}`;
}

export function programPaneHref(programId, module, pane) {
  return programStepHref(programId, module, pane);
}

/** @deprecated use programStepHref */
export function programFocusHref(focus) {
  return focus === "overview" ? "/program" : `/program?module=${encodeURIComponent(focus)}`;
}
